/* eslint-disable no-undef */
const UNSPLASH_ACCESS_KEY = process.env.VUE_APP_UNSPLASH_ACCESS_KEY;
const UNSPLASH_BASE_API = process.env.VUE_APP_UNSPLASH_BASE_API;

/**
 * @NOTE - NIKJOV
 * If query string has more than one word, unsplash returns 403 Forbidden Rate Limit Exceeded
 */

const IMAGES_PER_PAGE = 5;
export function useUnsplashServices() {
  const page = ref(1);
  async function fetchUnsplashPictures(_query) {
    const query = new URLSearchParams({
      client_id: UNSPLASH_ACCESS_KEY,
      query: String(_query),
      per_page: IMAGES_PER_PAGE,
      page: 1
    });
    const {
      data
    } = await useFetch(`${UNSPLASH_BASE_API}/search/photos?${query.toString()}`);
    page.value = 1;
    return data;
  }
  async function fetchUnsplashInfinite(_query) {
    page.value += 1;
    const query = new URLSearchParams({
      client_id: UNSPLASH_ACCESS_KEY,
      query: String(_query),
      per_page: IMAGES_PER_PAGE,
      page: page.value
    });
    const {
      data
    } = await useFetch(`${UNSPLASH_BASE_API}/search/photos?${query.toString()}`);
    return data;
  }
  return {
    fetchUnsplashPictures,
    fetchUnsplashInfinite
  };
}